'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { setLocalStorageItem } from '@marketplace-web/browser/browser-storage-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useSession } from '@marketplace-web/shared/session-data'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import {
  getFeedbackType,
  CURRENT_SURVEY_VERSION,
  DENY_AUTOMATED_SUPPORT_FEEDBACK,
} from '@marketplace-web/help-center-conversation-support/help-center-automated-feedback-feature'
import {
  continueConversationClicked,
  getIsAutomatedSupportFeedbackEnabled,
  requestFurtherHelp,
} from '@marketplace-web/conversation-feedback/conversation-feedback-data'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

const DenyAutomatedSupportFeedback = ({
  primary,
  title,
  inverse,
  theme,
  size,
  action,
}: Partial<ConversationActionProps>) => {
  const { fetch, isLoading: isFetchFeedbackEnabledLoading } = useFetch(
    getIsAutomatedSupportFeedbackEnabled,
  )

  const userId = useSession().user?.id
  const { conversation } = useConversationContext()
  const conversationId = conversation?.id
  const { helpCenterSessionId } = useHelpCenterSessionTracking()
  const { track } = useTracking()

  async function handleButtonClick() {
    if (!userId || !conversationId || !helpCenterSessionId) return

    track(
      continueConversationClicked({
        threadId: conversationId?.toString(),
        helpCenterSessionId,
        supportType: getFeedbackType(action),
      }),
    )

    const response = await fetch({
      userId,
      surveyVersion: CURRENT_SURVEY_VERSION,
      conversationId: conversationId.toString(),
    })

    if (response.data?.enabled) {
      setLocalStorageItem(DENY_AUTOMATED_SUPPORT_FEEDBACK, conversationId.toString())
    }

    await requestFurtherHelp({
      userId,
      conversationId: conversationId.toString(),
      helpCenterSessionId,
    })
  }

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleButtonClick}
      isLoading={isFetchFeedbackEnabledLoading}
    />
  )
}

export default DenyAutomatedSupportFeedback
